import classNames from 'classnames';
import React from 'react';
import TargetBlankIcon from '../icons/TargetBlankIcon';
import './styles.css';

const Invoices = ({data}) => {
  return (
    <div className={'invoice__container'}>
      <table className={'invoice__table'}>
        <tbody>
          {data.map((invoice, index) => (
            <tr className={'invoice__line'} key={index}>
              <td>
                <a className={'invoice__url'} href={invoice.url} target={'_blank'}>
                  {invoice.date}
                  <TargetBlankIcon size={12} />
                </a>

                <div className={'invoice__mobile'}>
                  <div>${invoice.amount}</div>
                  <div>
                    <span className={classNames('invoice__status', `invoice__status--${invoice.status.toLocaleLowerCase().replace(' ', '-')}`)}>
                      {invoice.status}
                    </span>
                  </div>
                </div>
              </td>
              <td>${invoice.amount}</td>
              <td>
                <span className={classNames('invoice__status', `invoice__status--${invoice.status.toLocaleLowerCase().replace(' ', '-')}`)}>
                  {invoice.status}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
};

export default Invoices;
